module.exports = __webpack_public_path__ + "19f5dcf61a4ecf8060b62754cfd778ee.jpg";